module.exports = __webpack_public_path__ + "fc987c2272afd101b4a2b453788a001c.woff";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/TiemposTextWeb-Bold.woff
// module id = 1101
// module chunks = 0